import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { RadioButton } from "../../../../../ui/RadioButton/RadioButton";
import { secondaryTireFilters } from "../secondaryTireFilters";
import { useSeasonList } from "./useSeasonList";
import { useTireSeason } from "./useTireSeason";

export const TireSeasonFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(
    "dealer-tire-season-panel",
    true
  );
  const { t } = useTranslation();
  const [selectedSeason, setSelectedSeason] = useTireSeason();
  const seasonList = useSeasonList();
  return (
    <Collapsible
      className=" space-y-2"
      id="season-select"
      label={t("searchResults.season")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {seasonList.map(({ name, value }) => (
        <label className="flex items-center gap-x-4" key={value}>
          <RadioButton
            onChange={(): void => {
              setSelectedSeason(value, secondaryTireFilters);
            }}
            checked={value === selectedSeason}
            checkedClassName="text-selected-tab"
            name="season"
            value={value}
          />
          <span className="flex-1 w-full">{name}</span>
        </label>
      ))}
    </Collapsible>
  );
};
